import { formConfig } from '@config/formConfig';

export default {
    path: global.window.Config.targetApi
};

export const EfArray = {
    url: 'https://cours.lecolefrancaise.fr/moncompteformation-faire-ma-demande/array-formation-links.php',
    token: formConfig.efArray.token,
    getting: 1
};

export const apiGateway = {
    path: 'https://api.lecolefrancaise.fr/v1/',
    endpoint: {
        consents: {
            phrases: 'consent/get-phrases/'
        },
        formation: {
            byId: 'formation-by-bitrix-id/'
        }
    }
};

export const gcp = {
    cloudStorageUrl: 'https://storage.googleapis.com/form_lead/medias/'
};
